import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AppBar from "@/components/@common/AppBar";
import { useAppBar } from "@/hooks/useAppBar";
import { LOGIN_WITH_PHONE_PAGE, SIGNUP_AFTER_USER_PROFILE, SIGNUP_WITH_PHONE } from "@/settings/constant";
import { styled } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React from "react";
const MemberPageLayoutContainer = styled("main")((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        height: "100%",
        minHeight: "100svh",
        overflow: "auto",
        backgroundColor: theme.palette.grey[0],
        [theme.breakpoints.down("lg")]: {
            backgroundColor: theme.palette.blackAndWhite.white
        }
    };
});
// 앱바를 숨길 페이지
const hideAppBarPages = [
    LOGIN_WITH_PHONE_PAGE,
    SIGNUP_WITH_PHONE,
    SIGNUP_AFTER_USER_PROFILE
];
export const MemberPageLayout = observer((param)=>{
    let { children  } = param;
    const router = useRouter();
    const { items: appBarItems , activeKey: appBarActiveKey  } = useAppBar();
    const hideAppBar = hideAppBarPages.includes(router.pathname);
    return /*#__PURE__*/ _jsxs(MemberPageLayoutContainer, {
        children: [
            children,
            !hideAppBar && /*#__PURE__*/ _jsx(AppBar, {
                items: appBarItems,
                activeKey: appBarActiveKey
            })
        ]
    });
});
